import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useToast } from './AdminToast';

const ManageAdmins = () => {
    const [admins, setAdmins] = useState([]);
    const [loading, setLoading] = useState(true);
    const toast = useToast();
    const adminToken = localStorage.getItem("adminToken");

    useEffect(() => {
        fetchAdmins();
    }, []);

    const fetchAdmins = async () => {
        try {
            const baseUrl = window.location.hostname === 'localhost' ? 'http://localhost:5000' : '';
            const res = await axios.get(`${baseUrl}/api/admin/admins`, {
                headers: { Authorization: `Bearer ${adminToken}` }
            });
            setAdmins(res.data);
        } catch (err) {
            console.error("Fetch admins error:", err);
            let msg = err.message;
            if (err.response && err.response.data) {
                msg = (err.response.data && err.response.data.error) || (err.response.data && err.response.data.msg) || msg;
            }
            toast.error(msg || "Failed to load admins");
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (id, email) => {
        if (!window.confirm(`Are you sure you want to remove ${email}?`)) return;

        try {
            const baseUrl = window.location.hostname === 'localhost' ? 'http://localhost:5000' : '';
            await axios.delete(`${baseUrl}/api/admin/admins/${id}`, {
                headers: { Authorization: `Bearer ${adminToken}` }
            });
            toast.success("Admin removed successfully");
            setAdmins(admins.filter(a => a.id !== id));
        } catch (err) {
            console.error("Delete admin error:", err);
            let msg = err.message;
            if (err.response && err.response.data) {
                msg = (err.response.data && err.response.data.error) || (err.response.data && err.response.data.msg) || msg;
            }
            toast.error(msg || "Failed to remove admin");
        }
    };

    return (
        <div className="p-6 bg-[#0f172a] min-h-screen text-white">
            <div className="max-w-4xl mx-auto">
                <div className="flex justify-between items-center mb-8">
                    <div>
                        <h1 className="text-3xl font-black italic tracking-tighter text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-500 uppercase">
                            Admin Management
                        </h1>
                        <p className="text-gray-400 text-xs mt-1 uppercase tracking-widest font-bold">Manage panel access and security</p>
                    </div>
                </div>

                {loading ? (
                    <div className="flex justify-center py-20">
                        <div className="w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
                    </div>
                ) : (
                    <div className="grid gap-4">
                        {admins.map((admin) => (
                            <div key={admin.id} className="bg-[#1e293b] p-5 rounded-2xl border border-white/5 flex justify-between items-center group hover:border-blue-500/30 transition-all shadow-xl">
                                <div className="flex items-center gap-4">
                                    <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-purple-600 rounded-xl flex items-center justify-center text-xl font-bold shadow-lg">
                                        {admin.email[0].toUpperCase()}
                                    </div>
                                    <div>
                                        <h3 className="font-bold text-lg">{admin.email}</h3>
                                        <p className="text-gray-500 text-[10px] uppercase tracking-wider font-bold">
                                            Added on: {new Date(admin.created_at).toLocaleDateString()}
                                        </p>
                                    </div>
                                </div>
                                
                                <button 
                                    onClick={() => handleDelete(admin.id, admin.email)}
                                    className="px-4 py-2 bg-red-500/10 hover:bg-red-500 text-red-500 hover:text-white rounded-xl text-xs font-black uppercase tracking-widest transition-all border border-red-500/20 group-hover:scale-105"
                                >
                                    Remove Access
                                </button>
                            </div>
                        ))}

                        {admins.length === 0 && (
                            <div className="text-center py-20 bg-[#1e293b] rounded-3xl border border-dashed border-white/10">
                                <p className="text-gray-500 font-bold uppercase tracking-widest">No other admins found</p>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ManageAdmins;
